var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"dark","content":"复制","placement":"top"}},[_c('i',{ref:"CopyIcon",staticClass:"el-icon-copy-document",attrs:{"data-clipboard-text":_vm.copyValue}})])}
var staticRenderFns = []

export { render, staticRenderFns }